import {gsap} from "gsap";
import {BitmapText} from "pixi.js";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {MathUtils} from "../../utils/MathUtils";
import {SpineLamp, LampState} from "./SpineLamp";
import {DasUBootGameMode} from "../../server/DasUBootGameMode";
import {DasUBootSound} from "../../sound/DasUBootSound";

/**
 * Created by jonas on 2021-03-10.
 */

export class NudgeLamp extends SpineLamp {
    public textDisplay:PIXI.BitmapText;
    private readonly prefix:string = "X";
    private _bigNumber:PIXI.BitmapText;


    constructor(spinePath:string = DasUBootGameAssets.LAMP_X_WAYS) {
        super();

        this._spine = new PIXI.spine.Spine(DasUBoot.assetLoader.getSpineAsset(spinePath));
        this.addChild(this._spine);

        this.textDisplay = new BitmapText("X0", {fontName:"Multiplier", fontSize:78, tint:0xffffff});
        this.textDisplay.anchor = new PIXI.Point(0.5, 0.5);
        this.textDisplay.position.set(22, 3);
        this.textDisplay.visible = false;

        this._bigNumber = new BitmapText("X0", {fontName:"Multiplier", fontSize:156, tint:0xffffff});
        this._bigNumber.anchor = new PIXI.Point(0.5, 0.5);
        this._bigNumber.position.set(0,-470);
        this._bigNumber.alpha = 0;


        this.addChild(this._bigNumber);
        this.addChild(this.textDisplay);
        this.setValue(-1);
    }

    public setValue(value:number, animated:boolean = false, finalValue?:number):gsap.core.Timeline {
        const tl = super.setValue(value,animated,finalValue);

        const lastIncrement = value == finalValue;

        tl.add(() => {
            this.value = value;
            this.textDisplay.visible = false;
        });

        if (animated){

            const targetScale = MathUtils.map(value, 2,8, 1, 2.2);
            if (lastIncrement){
                tl.add(this.setValueBigNumber(value, targetScale));
                tl.add(()=>DasUBoot.soundPlayer.playSound(DasUBootSound.WILD_NUDGE_MULTIPLIER), "<");
                tl.add(this.moveBigNumber());
                tl.add(()=>DasUBoot.soundPlayer.playSound(DasUBootSound.WILD_NUDGE_MULTIPLIER_DOWN), "<");
                tl.add(() => {
                    this.setState(LampState.ON);
                    this.textDisplay.scale.set(targetScale,targetScale);
                    this.textDisplay.text = `${this.prefix}${this.value}`;
                    this.textDisplay.visible = true;
                });

            }
            else {
                tl.add(()=>{this.setValueBigNumber(value, targetScale)});
                tl.add(()=>DasUBoot.soundPlayer.playSound(DasUBootSound.WILD_NUDGE_MULTIPLIER), "<");
            }

        }
        tl.add(gsap.to(this, {duration:0.001}));
        return tl;
    }

    private setValueBigNumber(value:number, targetScale:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(()=>{
            const isSuperFS = DasUBoot.model.data.mode == DasUBootGameMode.SUPER_FREESPIN;
            this._bigNumber.position.set(0, isSuperFS ? -470 : -326);
            this._bigNumber.text = "X" + value;
        })
        tl.add(gsap.to(this._bigNumber, {duration:0.2, pixi:{scale:targetScale, alpha:1},  ease:"back.out(4)"}));

        return tl;

    }

    private moveBigNumber():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const targetScale = this._bigNumber.scale.x * 0.5;

        tl.add(gsap.to(this._bigNumber, {duration:0.3, pixi:{positionX:this.textDisplay.position.x, positionY:this.textDisplay.position.y, scale:targetScale},  ease:"Power2.out"}));
        tl.add(()=>{gsap.to(this._bigNumber, {duration:0.01, pixi:{alpha:0},  ease:"none"})});

        return tl;

    }
}